import { Navigate, useRoutes } from 'react-router-dom';
// layouts
import DashboardLayout from './layouts/dashboard';
import SimpleLayout from './layouts/simple';
//
import SettingsPage from './pages/SettingsPage';
import UserPage from './pages/UserPage';
import LoginPage from './pages/LoginPage';
import Page404 from './pages/Page404';
import ReportsPage from './pages/Reports';
import DashboardAppPage from './pages/DashboardAppPage';
import RegisterPage from './pages/RegisterPage';
import LogisticsPage from './pages/logistics';
import DepotLogisticsPage from './pages/DepotLogisticsPage';
import DepotFinancialPage from './pages/DepotFinancialPage';
import ProductsPage from './pages/ProductsPage';
import Organogram from './pages/organogram';
import PrivateRoute from './components/private-route/PrivateRoute';
import DashboardCard from './pages/DashboardCard';
import ResetPassword from './pages/ResetPassword';
import HoneyBadgerMarketplacePage from './pages/HoneyBadgerMarketplacePage';

// ----------------------------------------------------------------------
const SHOW_PRODUCTS_PAGE = false;

export default function Router() {
  const routes = useRoutes([
    {
      path: '/dashboard',
      element: <PrivateRoute element={<DashboardLayout /> } />,
      children: [
        { element: <PrivateRoute element={<Navigate to="/dashboard/app" />} />, index: true },
        { path: 'app', element: <PrivateRoute element={<DashboardAppPage />} /> },
        { path: 'user', element: <PrivateRoute element={<UserPage />} /> },
        { path: 'reports', element: <PrivateRoute element={<ReportsPage />} /> },
        { path: 'logistics', element: <PrivateRoute element={<LogisticsPage />} /> },
        { path: 'logistics-tab', element: <PrivateRoute element={<DepotLogisticsPage />} /> },
        { path: 'financial-tab', element: <PrivateRoute element={<DepotFinancialPage />} /> },
        {
          path: 'products',
          element: (
            <PrivateRoute
              element={
                SHOW_PRODUCTS_PAGE ? <ProductsPage /> : <Navigate to="/dashboard/app" replace />
              }
            />
          ),
        },
        { path: 'organogram', element: <PrivateRoute element={<Organogram />} /> },
        { path: 'finances', element: <PrivateRoute element={<DepotFinancialPage />} /> },
        { path: 'settings', element: <PrivateRoute element={<SettingsPage />} /> },
        { path: 'cards', element: <PrivateRoute element={<DashboardCard />} /> },
      ],
    },
    {
      path: 'login',
      element: <LoginPage />,
    },
    {
      path: 'honeybadger-marketplace',
      element: <HoneyBadgerMarketplacePage />,
    },
    {
      path: 'marketplace',
      element: <HoneyBadgerMarketplacePage />,
    },
    {
      path: 'register',
      element: <RegisterPage />,
    },
    {
      path: 'reset-password',
      element: <ResetPassword />,
    },
    {
      element: <SimpleLayout />,
      children: [
        { element: <Navigate to="/dashboard/app" />, index: true },
        { path: '404', element: <Page404 /> },
        { path: '*', element: <Navigate to="/404" /> },
      ],
    },
    {
      path: '*',
      element: <Navigate to="/404" replace />,
    },
  ]);

  return routes;
}
